import React, {useMemo} from 'react';

import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';
import {Highlight, getIndexesOfMatches} from '@pb/kit-component-highlight';

type Props = {
    description: string,
    query: string,
    onEntityClick: (entityName: string) => void,
};

export const ChangeLogDescription = ({description, query, onEntityClick}: Props) => {
    const chunks = useMemo(() => {
        const buffer = (description ?? '').split("'");
        return buffer.map((chunk, index) => (index !== buffer.length - 1 ? `${chunk}'` : chunk));
    }, [description]);

    const queryChunks = useMemo(() => {
        const buffer = (query ?? '').split("'");
        return buffer.map((chunk, index) => {
            if (buffer.length === 1) {
                return chunk;
            }

            if (query.endsWith("'")) {
                return `${chunk}'`;
            } else if (index === buffer.length - 1) {
                return chunk;
            }

            return `${chunk}'`;
        });
    }, [query]);

    return (
        <EllipsisTextHint title={chunks.join('')}>
            {chunks.map((chunk, chunkIndex) => {
                const matchedQuery =
                    queryChunks.find(queryChunk => chunk.startsWith(queryChunk)) ||
                    queryChunks.find(queryChunk => chunk.endsWith(queryChunk)) ||
                    queryChunks.find(queryChunk => chunk.includes(queryChunk)) || '';

                if (chunkIndex % 2 === 1) {
                    return (
                        <a key={chunkIndex} onClick={() => onEntityClick(chunk.slice(0, -1))}>
                            <b>
                                <Highlight text={chunk} matchedChunks={getIndexesOfMatches(chunk, matchedQuery)}/>
                            </b>
                        </a>
                    );
                } else {
                    return (
                        <span key={chunkIndex}>
                            <Highlight
                                text={chunk}
                                matchedChunks={getIndexesOfMatches(chunk, matchedQuery)}
                            />
                        </span>
                    );
                }
            })}
        </EllipsisTextHint>
    );
};
